// Who the CRM lets in (#1331): a user whose ID token carries the { admin: true } claim, and nobody
// else. isAdmin() in firestore.rules and the admin callables test the same claim, so the page opens
// the CRM for exactly the people the server will answer. An email is not a second way in: it opened
// a CRM whose admin reads and calls were all refused, and it put the address into a file that
// anyone can fetch.

// Resolves to { isAdmin, error }. The token is refreshed first, so a claim granted or revoked since
// the last sign-in counts. When that fails nobody is let in, and `error` says why.
export async function checkAdminAccess(user) {
  try {
    const tokenResult = await user.getIdTokenResult(true);
    return { isAdmin: tokenResult.claims.admin === true, error: null };
  } catch (error) {
    console.error("Error checking admin claim:", error);
    return { isAdmin: false, error };
  }
}

// What the Access denied screen and the sign-in toast say. A check that failed is not a missing
// claim and must not read like one: the account may well hold it.
export function accessDeniedMessage(email, error) {
  if (error) {
    return `Access Denied: could not check whether Google account (${email}) has the { admin: true } claim (${error.code || error.message}). Reload the page to try again.`;
  }
  return `Access Denied: Google account (${email}) does not have the { admin: true } claim in Firebase.`;
}
